import DefaultLayout from './DefaultLayout';
import ChemistryLayout from './ChemistryLayout';
import ComplexMathLayout from './ComplexMathLayout';
import PhysicsLayout from './PhysicsLayout';
import SimpleMathLayout from './SimpleMathLayout';

const KEYPAD_LAYOUT = {
  MATHS: 'maths',
  CHEMISTRY: 'chemistry',
  BIOLOGY: 'biology',
  PHYSICS: 'physics',
  SIMPLE_MATHS: 'simple_maths',
};

const KeypadLayoutFactory = {
  create: (type, props) => {
    switch (type) {
      case KEYPAD_LAYOUT.CHEMISTRY:
        return <ChemistryLayout {...props} />;
      case KEYPAD_LAYOUT.PHYSICS:
        return <PhysicsLayout {...props} />;
      case KEYPAD_LAYOUT.MATHS:
        return <ComplexMathLayout {...props} />;
      case KEYPAD_LAYOUT.SIMPLE_MATHS:
        return <SimpleMathLayout {...props} />;
      default:
        return <DefaultLayout {...props} />;
    }
  },
};

export default KeypadLayoutFactory;
export { KEYPAD_LAYOUT };
